export const SET_SCREEN_SIZE = 'service.SET_SCREEN_SIZE';
export const SET_SMALL_SCREEN = 'service.SET_SMALL_SCREEN';
